import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-location-tabs',
    templateUrl: './location-tabs.component.html',
    styleUrls: ['./location-tabs.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LocationTabsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
